/* eslint-disable @typescript-eslint/naming-convention */
import 'reflect-metadata';
import {FormElement, FormElementConfiguration} from 'app/entities/form/formElement.entity';
import {Type} from 'class-transformer';
import {FormElementCheckboxConfiguration} from 'app/entities/form/formElementCheckbox.entity';
import {FormElementType} from 'app/entities/enums';

export class FormElementTextarea extends FormElement {
  type: FormElementType = 'textarea';

  @Type(() => FormElementCheckboxConfiguration)
  configuration?: FormElementTextareaConfiguration = new FormElementTextareaConfiguration();
}

export class FormElementTextareaConfiguration extends FormElementConfiguration {
  minLength?: number = null;
  maxLength?: number = null;
  clearable= true;
}
